import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f06e42f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "party-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container-blue" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Welke partij past bij jou? "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Kies een partij.")
  ])
], -1))
const _hoisted_3 = { id: "party-container" }
const _hoisted_4 = { id: "grid" }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = { id: "container-dark-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parties, (party, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `party-logo-${i}`,
            class: "grid-item"
          }, [
            _createElementVNode("img", {
              src: party.image,
              onClick: ($event: any) => (_ctx.setParty(i))
            }, null, 8, _hoisted_5),
            _createVNode(_component_checkbox, {
              modelValue: _ctx.active === i,
              "onUpdate:modelValue": ($event: any) => (_ctx.setParty(i))
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_submit_button, {
        id: "submit-button",
        href: "/slogan-kiezen",
        disabled: !_ctx.hasParty
      }, {
        default: _withCtx(() => [
          _createTextVNode("OK")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}